import { useCallback, useContext, useRef } from 'react'
import { BsPlus } from 'react-icons/bs'

import { Button } from '~/components/Button'
import { SearchInput } from '~/components/SearchInput'

import { managersContext } from '../context'
import { CreateAdminModal } from './CreateAdminModal'

export const Header: React.FC = () => {
  const { handleUpdateQuery } = useContext(managersContext)

  const modalRef = useRef<CreateAdminModal>(null)

  const handleOpenModal = useCallback(() => {
    modalRef.current?.showModal()
  }, [])

  return (
    <div
      className='flex items-center justify-between p-2 py-3 border-b-2
      bg-white border-b-slate-300'
    >
      <div className='max-w-[270px]'>
        <SearchInput
          placeholder='Buscar por nome ou e-mail'
          onChange={handleUpdateQuery}
        />
      </div>
      <div className='max-w-[270px]'>
        <Button onClick={handleOpenModal}>
          <BsPlus size={26} /> Novo Administrador
        </Button>

        <CreateAdminModal ref={modalRef} />
      </div>
    </div>
  )
}
